export const getYearsIntervalText = (t, months) => {
    if (months === 12)
        return t('badges.badgeList.analytics.yearsInterval', { count: 1 });
    if (months > 12 && months % 12 === 0)
        return t('badges.badgeList.analytics.yearsInterval', { count: months / 12 });
    return t('badges.badgeList.analytics.monthsInterval', { count: months });
};
